export default __webpack_public_path__ + "static/media/tune_upwards2.8d98da65.jpg";